import { GzToastNotificationWebComponent } from '../../../../../apps/webcomponents/src';
import { ToastSeverity } from '../../../../../apps/webcomponents/src/ui/gzToastNotification/type';
import { BaseWebComponentTranslator } from '../../../../../apps/webcomponents/src/framework/BaseWebComponentTranslator';

export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function showSuccessToast(message: string): void {
  showToast(message, ToastSeverity.SUCCESS);
}

export function showErrorToast(error: Error): void {
  const errorMessage = error?.message || BaseWebComponentTranslator.getInstance().getGenericErrorMessage();

  showToast(errorMessage, ToastSeverity.ERROR);
}

export function showToast(message: string, severity: ToastSeverity): void {
  GzToastNotificationWebComponent.buildToastWrapperElement({ message: message, severity: severity });
}
